import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import { PAYOUT_ACCOUNT } from 'sh-www/models/payout-account';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

class SettingsPayoutAddMethodSelectMethodController extends Controller {
  @service('state-managers/application') applicationStateManager;
  @service('commands/payout-account-commands') payoutAccountCommands;
  @service router;
  @service session;
  @service shData;
  @service store;

  /** @type {Boolean} */
  isSubmitting = false;

  @dropTask
  *loadPayoutAccount() {
    try {
      const user = yield this.store.findRecord('user', this.session.currentUser.id, {
        include: 'payout-accounts',
        reload: true,
      });

      const payoutAccount = user.payoutAccounts.find((payoutAccount) => {
        return payoutAccount.id === this.model.payoutAccountId;
      });

      this.set('model.payoutAccount', payoutAccount);
    } catch (error) {
      handleErrorResponseWithModal(this, error);
    }
  }

  @action
  handleDismiss() {
    const payoutAccount = this.model.payoutAccount;

    if (payoutAccount.status !== PAYOUT_ACCOUNT.STATUSES.UNLINKED) {
      this.router.transitionTo('settings.payout');
      this.applicationStateManager.addToast('Payout method added');
      return;
    }

    this.set('isSubmitting', true);

    this.payoutAccountCommands.setLinkedStatus(payoutAccount, true)
      .then(() => {
        return this.payoutAccountCommands.syncPayoutAccounts(this.session.currentUser);
      })
      .then((response) => {
        this.shData.pushResponseToStore(response);
        this.router.transitionTo('settings.payout');
        this.applicationStateManager.addToast('Payout method added');
      })
      .catch((error) => {
        handleErrorResponseWithModal(this, error);
      })
      .finally(() => {
        this.set('isSubmitting', false);
      });
  }

  @action
  handleSelect() {
    this.set('isSubmitting', true);

    this.payoutAccountCommands.setPayoutAccountPreferred(this.model.payoutAccountId)
      .then(() => {
        this.router.transitionTo('settings.payout');
        this.applicationStateManager.addToast('Payout method added');
      })
      .catch((error) => {
        handleErrorResponseWithModal(this, error);
      })
      .finally(() => {
        this.set('isSubmitting', false);
      });
  }
}

export default SettingsPayoutAddMethodSelectMethodController;
